// client/src/components/ui/UpdateBanner.tsx

import { useState, useEffect } from "react";
import { Button } from "./button";
import { RefreshCw } from "lucide-react";

export function UpdateBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    // Detectar cuando hay una nueva versión del Service Worker
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        // Escuchar cuando se encuentra una actualización
        registration.addEventListener("updatefound", () => {
          console.log("🆕 Nueva versión detectada, mostrando banner");
          setShowBanner(true);
        });
      });

      // También escuchar cuando el controlador cambia (ya se actualizó)
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        console.log("🔄 Service Worker actualizado");
        setIsUpdating(false);
        setShowBanner(false);
      });
    }
  }, []);

  const handleUpdate = () => {
    setIsUpdating(true);
    console.log("🔄 Forzando actualización...");

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        if (registration.waiting) {
          // Enviar mensaje al Service Worker para que tome control
          registration.waiting.postMessage({ type: "SKIP_WAITING" });
        } else {
          // Si no hay waiting, recargar directamente
          window.location.reload();
        }
      });
    }
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 right-4 left-4 md:left-auto md:w-96 z-50 animate-in slide-in-from-bottom-5 duration-300">
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg shadow-xl p-4 border border-blue-400">
        <div className="flex items-start gap-3">
          <div className="flex-1">
            <h3 className="font-bold text-sm mb-1">
              🆕 Nueva versión disponible
            </h3>
            <p className="text-xs text-blue-100 mb-3">
              Hay una nueva versión de la aplicación. Actualiza para obtener las
              últimas mejoras.
            </p>
            <div className="flex gap-2">
              <Button
                size="sm"
                variant="secondary"
                className="bg-white text-blue-700 hover:bg-blue-50 text-xs h-8 px-3"
                onClick={handleUpdate}
                disabled={isUpdating}
              >
                {isUpdating ? (
                  <>
                    <RefreshCw className="h-3 w-3 mr-1 animate-spin" />
                    Actualizando...
                  </>
                ) : (
                  "Actualizar ahora"
                )}
              </Button>
              <Button
                size="sm"
                variant="ghost"
                className="text-white hover:bg-blue-800 text-xs h-8 px-3"
                onClick={() => setShowBanner(false)}
              >
                Más tarde
              </Button>
            </div>
          </div>
          <button
            onClick={() => setShowBanner(false)}
            className="text-blue-200 hover:text-white transition-colors"
          >
            <span className="sr-only">Cerrar</span>
            <svg
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
